import type { Chat } from '../../Authentication/chat/use-chat';
import { ChatThread } from '../../Authentication/chat/ChatThread';

type TipsPanelProps = { chat: Chat };

/**
 * The right half: the same blue surface as the sign-in chat (AuthChatPanel), holding the
 * team's tips for the step the person is on. Full height beside the form, short when the
 * columns stack under it, as on the auth screens.
 */
export const TipsPanel = ({ chat }: TipsPanelProps) => (
  <div className="h-[560px] min-w-0 flex-[1.05_1_460px] min-[910px]:h-[max(660px,calc(100vh-20px))]">
    <aside
      aria-label="Setup tips"
      className="flex h-full w-full flex-col gap-5 overflow-hidden rounded-[16px] border border-[var(--accentLine)] bg-[color-mix(in_oklch,hsl(var(--accent))_7%,hsl(var(--panel)))] px-8 pt-7 pb-6"
    >
      <div className="flex justify-end">
        <span className="micro-label">Tips</span>
      </div>

      <ChatThread thread={chat.thread} typing={chat.typing} />

      <div className="border-t border-[var(--accentLine)] pt-4">
        <span className="text-dim text-micro">Stuck? Your developer can add the snippet later.</span>
      </div>
    </aside>
  </div>
);
